<template>
	<div class="invitation-accept">
		<h1>Accept invitation</h1>
		<spinner v-if="loading"/>
		<div v-if="success">{{ success }}</div>
		<error-box v-if="error" :error="error"/>
	</div>
</template>

<script>
export default {
	props: [
		'user_uid',
		'invitation_id'
	],
	data () {
		return {
			loading: false,
			success: null,
			error: null
		}
	},
	methods: {
		acceptInvitation () {
			this.loading = true
			this.$api.invitations.accept(this, this.user_uid, this.invitation_id)
				.then(response => {
					this.$log.info('invitation accept', 'invitations.accept OK', response)()
					this.success = response.body.message
					this.$store.dispatch('getAccounts', { context: this, user_uid: this.user_uid })
					this.$store.dispatch('getPermissions', { context: this, user_uid: this.user_uid })
				})
				.catch(error => {
					this.$log.error('invitation accept', 'invitations.accept ERROR', error)()
					this.error = error
				})
				.finally(() => {
					this.loading = false
				})
		}
	},
	mounted () {
		this.acceptInvitation()
	}
}
</script>



// WEBPACK FOOTER //
// src/components/user/invitations/InvitationAccept.vue